import { StretchParam } from "../StretchParam";
import { LayoutChangedReason, LayoutType, StretchMode } from "../Const";
import { SerializeUtil } from "../../loaders/SerializeUtil";
import { Point } from "../../maths/Point";
import { Rectangle } from "../../maths/Rectangle";
import { ILaya } from "../../../ILaya";
import { NodeFlags } from "../../Const";
import { Pool } from "../../utils/Pool";
import { UIEvent } from "../UIEvent";
import { SpriteUtils } from "../../utils/SpriteUtils";
export class Layout {
    constructor(owner) {
        this._type = 0;
        this._rows = 0;
        this._columns = 0;
        this._rowGap = 0;
        this._columnGap = 0;
        this._stretchX = 0;
        this._stretchY = 0;
        this._pageMode = false;
        this._align = 0;
        this._valign = 0;
        this._minChildSize = 0;
        this._contentWidth = 0;
        this._contentHeight = 0;
        this._owner = owner;
        this._padding = [0, 0, 0, 0];
        this._stretchParamsX = [];
        this._stretchParamsY = [];
    }
    get type() {
        return this._type;
    }
    set type(value) {
        var _a;
        if (this._type !== value) {
            this._type = value;
            if (!SerializeUtil.isDeserializing) {
                (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a._setDefaultDirection();
                switch (value) {
                    case LayoutType.SingleColumn:
                    case LayoutType.FlowX:
                        this._stretchY = StretchMode.None;
                        break;
                    case LayoutType.SingleRow:
                    case LayoutType.FlowY:
                        this._stretchX = StretchMode.None;
                        break;
                }
            }
            this.setChangedFlag();
        }
    }
    get rows() {
        return this._rows;
    }
    set rows(value) {
        if (this._rows !== value) {
            this._rows = value;
            this.setChangedFlag();
        }
    }
    get columns() {
        return this._columns;
    }
    set columns(value) {
        if (this._columns !== value) {
            this._columns = value;
            this.setChangedFlag();
        }
    }
    get rowGap() {
        return this._rowGap;
    }
    set rowGap(value) {
        if (this._rowGap !== value) {
            this._rowGap = value;
            this.setChangedFlag();
        }
    }
    get columnGap() {
        return this._columnGap;
    }
    set columnGap(value) {
        if (this._columnGap !== value) {
            this._columnGap = value;
            this.setChangedFlag();
        }
    }
    get padding() {
        return this._padding;
    }
    set padding(value) {
        var _a;
        if (value == null || !Array.isArray(value))
            value = [0, 0, 0, 0];
        this._padding = value;
        this.setChangedFlag();
        (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a._ownerSizeChanged();
    }
    get align() {
        return this._align;
    }
    set align(value) {
        if (this._align !== value) {
            this._align = value;
            this.setChangedFlag();
        }
    }
    get valign() {
        return this._valign;
    }
    set valign(value) {
        if (this._valign !== value) {
            this._valign = value;
            this.setChangedFlag();
        }
    }
    get stretchX() {
        return this._stretchX;
    }
    set stretchX(value) {
        if (this._stretchX !== value) {
            this._stretchX = value;
            this.setChangedFlag();
        }
    }
    get stretchY() {
        return this._stretchY;
    }
    set stretchY(value) {
        if (this._stretchY !== value) {
            this._stretchY = value;
            this.setChangedFlag();
        }
    }
    get stretchParamsX() {
        return this._stretchParamsX;
    }
    set stretchParamsX(value) {
        this._stretchParamsX.length = 0;
        this._stretchParamsX.push(...value);
    }
    get stretchParamsY() {
        return this._stretchParamsY;
    }
    set stretchParamsY(value) {
        this._stretchParamsY.length = 0;
        this._stretchParamsY.push(...value);
    }
    get foldInvisibles() {
        return this._foldInvisibles;
    }
    set foldInvisibles(value) {
        if (this._foldInvisibles != value) {
            this._foldInvisibles = value;
            this.setChangedFlag();
        }
    }
    get minChildSize() {
        return this._minChildSize;
    }
    set minChildSize(value) {
        if (this._minChildSize !== value) {
            this._minChildSize = value;
            this.setChangedFlag();
        }
    }
    get pageMode() {
        return this._pageMode;
    }
    set pageMode(value) {
        if (this._pageMode != value) {
            this._pageMode = value;
            this.setChangedFlag();
        }
    }
    getSnappingPosition(xValue, yValue, xDir, yDir, resultPoint) {
        if (!resultPoint)
            resultPoint = new Point();
        let children = this._owner.children;
        let cnt = children.length;
        if (cnt === 0) {
            resultPoint.x = 0;
            resultPoint.y = 0;
            return resultPoint;
        }
        this.refresh();
        let obj = null;
        let prev = null;
        let i = 0;
        if (yValue !== 0) {
            for (; i < cnt; i++) {
                obj = children[i];
                if (yValue < obj.top) {
                    if (i === 0) {
                        yValue = 0;
                        break;
                    }
                    else {
                        prev = children[i - 1];
                        if (yValue < prev.top + prev.height / 2)
                            yValue = prev.top;
                        else
                            yValue = obj.top;
                        break;
                    }
                }
            }
            if (i === cnt)
                yValue = obj.top;
        }
        if (xValue !== 0) {
            if (i > 0)
                i--;
            for (; i < cnt; i++) {
                obj = children[i];
                if (xValue < obj.left) {
                    if (i === 0) {
                        xValue = 0;
                        break;
                    }
                    else {
                        prev = children[i - 1];
                        if (xValue < prev.left + prev.width / 2)
                            xValue = prev.left;
                        else
                            xValue = obj.left;
                        break;
                    }
                }
            }
            if (i === cnt)
                xValue = obj.left;
        }
        resultPoint.x = xValue;
        resultPoint.y = yValue;
        return resultPoint;
    }
    setChangedFlag(reason) {
        if (this._layoutChanged)
            return;
        let layout = this._type;
        if (layout === LayoutType.None && !this._owner.scroller)
            return;
        if (reason === LayoutChangedReason.Visible && !this._foldInvisibles)
            return;
        if (reason === LayoutChangedReason.Pos && layout !== LayoutType.None)
            return;
        if (reason === LayoutChangedReason.Size)
            this._childSizeChangedFlag = true;
        this._layoutChanged = true;
        if (_dirtyLayouts.indexOf(this) === -1) {
            _dirtyLayouts.push(this);
            if (!_timerAdded) {
                _timerAdded = true;
                ILaya.timer.callLater(null, Layout.refreshAllLayouts);
            }
        }
    }
    refresh(force) {
        if (this._owner.destroyed || this._disabled) {
            this._layoutChanged = false;
            return;
        }
        if (force) {
            if (!this._layoutChanged)
                this._childSizeChangedFlag = true;
        }
        else if (!this._layoutChanged || this._refreshing)
            return;
        this._refreshing = true;
        switch (this._type) {
            case LayoutType.None:
                this.applyNone();
                break;
            case LayoutType.SingleRow:
                this.applyFlowX(true);
                break;
            case LayoutType.SingleColumn:
                this.applyFlowY(true);
                break;
            case LayoutType.FlowX:
                this.applyFlowX();
                break;
            case LayoutType.FlowY:
                this.applyFlowY();
                break;
        }
        this._refreshing = false;
        this._layoutChanged = false;
        this._childSizeChangedFlag = false;
    }
    get viewWidth() {
        var _a;
        let v = (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a.viewWidth;
        if (v == null)
            v = this._owner.width - this._padding[3] - this._padding[1];
        return v;
    }
    set viewWidth(value) {
        if (this._owner.scroller)
            this._owner.scroller.setViewSize(value, this._owner.scroller.viewHeight);
        else
            this._owner.width = value + this._padding[3] + this._padding[1];
    }
    get viewHeight() {
        var _a;
        let v = (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a.viewHeight;
        if (v == null)
            v = this._owner.height - this._padding[0] - this._padding[2];
        return v;
    }
    set viewHeight(value) {
        if (this._owner.scroller)
            this._owner.scroller.setViewSize(this._owner.scroller.viewWidth, value);
        else
            this._owner.height = value + this._padding[0] + this._padding[2];
    }
    get contentWidth() {
        return this._contentWidth;
    }
    get contentHeight() {
        return this._contentHeight;
    }
    setContentSize(aw, ah) {
        var _a;
        this._contentWidth = aw;
        this._contentHeight = ah;
        if (aw !== 0 && ah !== 0) {
            if (this._stretchX === StretchMode.ResizeToFit && this._stretchY === StretchMode.ResizeToFit) {
                if (this._owner.scroller)
                    this._owner.scroller.setViewSize(aw, ah);
                else
                    this._owner.size(aw + this._padding[3] + this._padding[1], ah + this._padding[0] + this._padding[2]);
            }
            else if (this._stretchX === StretchMode.ResizeToFit)
                this.viewWidth = aw;
            else if (this._stretchY === StretchMode.ResizeToFit)
                this.viewHeight = ah;
        }
        (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a._ownerContentSizeChanged();
        this._owner.event(UIEvent.ContentSizeChanged);
    }
    resizeToFit(childCount, minSize) {
        this.refresh();
        let curCount = this._owner.numChildren;
        if (childCount == null || childCount > curCount)
            childCount = curCount;
        minSize = minSize || 0;
        if (childCount === 0) {
            if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX)
                this.viewHeight = minSize;
            else
                this.viewWidth = minSize;
        }
        else {
            let i = childCount - 1;
            let obj = null;
            while (i >= 0) {
                obj = this._owner.getChildAt(i);
                if ((!this._foldInvisibles || obj._struct.enabled) && !obj._getBit(NodeFlags.ESCAPE_LAYOUT))
                    break;
                i--;
            }
            if (i < 0) {
                if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX)
                    this.viewHeight = minSize;
                else
                    this.viewWidth = minSize;
            }
            else {
                let size = 0;
                if (this._type === LayoutType.SingleColumn || this._type === LayoutType.FlowX) {
                    size = obj.y + obj.height;
                    if (size < minSize)
                        size = minSize;
                    this.viewHeight = size;
                }
                else {
                    size = obj.x + obj.width;
                    if (size < minSize)
                        size = minSize;
                    this.viewWidth = size;
                }
            }
        }
    }
    applyNone() {
        SpriteUtils.getChildrenBounds(this._owner, false, this._foldInvisibles, false, s_rect);
        this.setContentSize(Math.max(0, Math.ceil(s_rect.right)), Math.max(0, Math.ceil(s_rect.bottom)));
    }
    applyFlowX(singleRow) {
        var _a;
        let rows = this._rows;
        let cols = this._columns;
        let pageMode = this._pageMode;
        if (singleRow) {
            rows = 1;
            if (cols === 0 && !pageMode)
                cols = 1000000;
        }
        let rowGap = this._rowGap;
        let colGap = this._columnGap;
        let stretchX = this._stretchX === StretchMode.Stretch;
        let stretchY = this._stretchY === StretchMode.Stretch;
        let align = stretchX ? 0 : this._align;
        let valign = stretchY ? 0 : this._valign;
        let data = tempDataPool.take();
        let cnt = this.getLayoutChildren(data);
        let children = data.children;
        let vw = this.viewWidth, vh = this.viewHeight;
        let cx = 0, cy = 0;
        let px = 0, py = 0;
        let ci = 0, ri = 0;
        let cw = 0, ch = 0;
        let mh = 0;
        let pi = 0;
        if (stretchX) {
            if (cols === 0 || cnt < cols)
                cols = cnt;
            let stretchParamsX = this.checkStretchParams(this._stretchParamsX, data);
            for (let i = 0; i < cols; i++)
                data.swidth[i] = this._childSizeChangedFlag ? children[i].width : children[i]._giveWidth;
            this.handleStrecth(vw, cols, colGap, stretchParamsX, data.swidth, data.width);
        }
        if (cnt > 0 && stretchY) {
            if (rows === 0)
                rows = 1;
            for (let i = 0; i < rows; i++)
                data.sheight[i] = this._childSizeChangedFlag ? children[0].height : children[0]._giveHeight;
            this.handleStrecth(vh, rows, rowGap, this._stretchParamsY, data.sheight, data.height);
        }
        function newLine(i) {
            mh = Math.ceil(mh);
            if (cy !== 0)
                cy += rowGap;
            if (cx > cw)
                cw = cx;
            if (align === 1)
                cx = Math.floor((vw - cx) / 2);
            else if (align === 2)
                cx = vw - cx;
            else
                cx = 0;
            if (pageMode) {
                if ((cy + mh > vh || ri === rows) && cy !== 0) {
                    px += vw;
                    cy = 0;
                    pi++;
                    ri = 0;
                }
            }
            for (let j = i - ci; j < i; j++) {
                data.posx[j] += px + cx;
                data.posy[j] += py + cy;
            }
            cx = 0;
            cy += mh;
            mh = 0;
            ci = 0;
            ri++;
        }
        for (let x = 0; x < 2; x++) {
            for (let i = 0; i < cnt; i++) {
                let child = children[i];
                child.size(stretchX ? data.width[ci % cols] : child._giveWidth, stretchY ? data.height[ri % rows] : child._giveHeight, true);
                let sw = Math.ceil(child.width);
                if (cols === 0 && cx + colGap + sw > vw && cx !== 0) {
                    newLine(i);
                    child.size(stretchX ? data.width[ci] : child._giveWidth, stretchY ? data.height[ri % rows] : child._giveHeight, true);
                    sw = Math.ceil(child.width);
                }
                if (cx !== 0)
                    cx += colGap;
                data.posx[i] = cx;
                data.posy[i] = 0;
                if (singleRow) {
                    if (valign === 1)
                        data.posy[i] = Math.floor((vh - child.height) / 2);
                    else if (valign === 2)
                        data.posy[i] = vh - child.height;
                }
                cx += sw;
                if (child.height > mh)
                    mh = child.height;
                ci++;
                if (ci === cols && !singleRow || i === cnt - 1)
                    newLine(i + 1);
            }
            ch = py + cy;
            let checkOverflow = (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a._shouldCheckOverflow();
            if (checkOverflow == null)
                break;
            if (ch <= vh && stretchX && (checkOverflow & 1) !== 0) {
                vw += this._owner.scroller.vScrollBar.width;
                this.handleStrecth(vw, cols, colGap, this._stretchParamsX, data.swidth, data.width);
            }
            else
                checkOverflow &= ~1;
            if (cw <= vw && stretchY && (checkOverflow & 2) !== 0) {
                vh += this._owner.scroller.hScrollBar.height;
                this.handleStrecth(vh, rows, rowGap, this._stretchParamsY, data.sheight, data.height);
            }
            else
                checkOverflow &= ~2;
            if (checkOverflow === 0)
                break;
            cx = cy = px = py = ci = ri = cw = ch = mh = 0;
        }
        cy = 0;
        if (ch < vh && this._stretchY !== StretchMode.ResizeToFit && !singleRow) {
            if (valign === 1)
                cy = Math.floor((vh - ch) / 2);
            else if (valign === 2)
                cy = vh - ch;
        }
        cx = 0;
        if (this._stretchX === StretchMode.ResizeToFit) {
            if (align === 1)
                cx = Math.floor((cw - vw) / 2);
            else if (align === 2)
                cx = cw - vw;
        }
        if (!this._owner.scroller) {
            cx += this._padding[3];
            cy += this._padding[0];
        }
        if (singleRow && !stretchY && valign === 3) {
            for (let i = 0; i < cnt; i++)
                children[i].left = data.posx[i] + cx;
        }
        else {
            for (let i = 0; i < cnt; i++)
                children[i].setLeftTop(data.posx[i] + cx, data.posy[i] + cy);
        }
        if (pageMode)
            cw = vw * (pi + 1);
        this.setContentSize(cw, ch);
        tempDataPool.recover(data);
    }
    applyFlowY(singleColumn) {
        var _a;
        let rows = this._rows;
        let cols = this._columns;
        let pageMode = this._pageMode;
        if (singleColumn) {
            cols = 1;
            if (rows === 0 && !pageMode)
                rows = 1000000;
        }
        let rowGap = this._rowGap;
        let colGap = this._columnGap;
        let stretchX = this._stretchX === StretchMode.Stretch;
        let stretchY = this._stretchY === StretchMode.Stretch;
        let align = stretchX ? 0 : this._align;
        let valign = stretchY ? 0 : this._valign;
        let data = tempDataPool.take();
        let cnt = this.getLayoutChildren(data);
        let children = data.children;
        let vw = this.viewWidth, vh = this.viewHeight;
        let cx = 0, cy = 0;
        let px = 0, py = 0;
        let ci = 0, ri = 0;
        let cw = 0, ch = 0;
        let mw = 0;
        let pi = 0;
        if (cnt > 0 && stretchX) {
            if (cols === 0)
                cols = 1;
            for (let i = 0; i < cols; i++)
                data.swidth[i] = this._childSizeChangedFlag ? children[0].width : children[0]._giveWidth;
            this.handleStrecth(vw, cols, colGap, this._stretchParamsX, data.swidth, data.width);
        }
        if (stretchY) {
            if (rows === 0 || cnt < rows)
                rows = cnt;
            let stretchParamsY = this.checkStretchParams(this._stretchParamsY, data);
            for (let i = 0; i < rows; i++)
                data.sheight[i] = this._childSizeChangedFlag ? children[i].height : children[i]._giveHeight;
            this.handleStrecth(vh, rows, rowGap, stretchParamsY, data.sheight, data.height);
        }
        function newLine(i) {
            mw = Math.ceil(mw);
            if (cx !== 0)
                cx += colGap;
            if (cy > ch)
                ch = cy;
            if (valign === 1)
                cy = Math.floor((vh - cy) / 2);
            else if (valign === 2)
                cy = vh - cy;
            else
                cy = 0;
            if (pageMode) {
                if ((cx + mw > vw || ci === cols) && cx !== 0) {
                    py += vh;
                    cx = 0;
                    pi++;
                    ci = 0;
                }
            }
            for (let j = i - ri; j < i; j++) {
                data.posx[j] += px + cx;
                data.posy[j] += py + cy;
            }
            cy = 0;
            cx += mw;
            mw = 0;
            ri = 0;
            ci++;
        }
        for (let x = 0; x < 2; x++) {
            for (let i = 0; i < cnt; i++) {
                let child = children[i];
                child.size(stretchX ? data.width[ci % cols] : child._giveWidth, stretchY ? data.height[ri % rows] : child._giveHeight, true);
                let sh = Math.ceil(child.height);
                if (rows === 0 && cy + rowGap + sh > vh && cy !== 0) {
                    newLine(i);
                    child.size(stretchX ? data.width[ci % cols] : child._giveWidth, stretchY ? data.height[ri] : child._giveHeight, true);
                    sh = Math.ceil(child.height);
                }
                if (cy !== 0)
                    cy += rowGap;
                data.posx[i] = 0;
                data.posy[i] = cy;
                if (singleColumn) {
                    if (align === 1)
                        data.posx[i] = Math.floor((vw - child.width) / 2);
                    else if (align === 2)
                        data.posx[i] = vw - child.width;
                }
                cy += sh;
                if (child.width > mw)
                    mw = child.width;
                ri++;
                if (ri === rows && !singleColumn || i === cnt - 1)
                    newLine(i + 1);
            }
            cw = px + cx;
            let checkOverflow = (_a = this._owner.scroller) === null || _a === void 0 ? void 0 : _a._shouldCheckOverflow();
            if (checkOverflow == null)
                break;
            if (ch <= vh && stretchX && (checkOverflow & 1) !== 0) {
                vw += this._owner.scroller.vScrollBar.width;
                this.handleStrecth(vw, cols, colGap, this._stretchParamsX, data.swidth, data.width);
            }
            else
                checkOverflow &= ~1;
            if (cw <= vw && stretchY && (checkOverflow & 2) !== 0) {
                vh += this._owner.scroller.hScrollBar.height;
                this.handleStrecth(vh, rows, rowGap, this._stretchParamsY, data.sheight, data.height);
            }
            else
                checkOverflow &= ~2;
            if (checkOverflow === 0)
                break;
            cx = cy = px = py = ci = ri = cw = ch = mw = 0;
        }
        cx = 0;
        if (cw < vw && this._stretchX !== StretchMode.ResizeToFit && !singleColumn) {
            if (align === 1)
                cx = Math.floor((vw - cw) / 2);
            else if (align === 2)
                cx = vw - cw;
        }
        cy = 0;
        if (this._stretchY === StretchMode.ResizeToFit) {
            if (valign === 1)
                cy = Math.floor((ch - vh) / 2);
            else if (valign === 2)
                cy = ch - vh;
        }
        if (!this._owner.scroller) {
            cx += this._padding[3];
            cy += this._padding[0];
        }
        if (singleColumn && !stretchX && align === 3) {
            for (let i = 0; i < cnt; i++)
                children[i].top = data.posy[i] + cy;
        }
        else {
            for (let i = 0; i < cnt; i++)
                children[i].setLeftTop(data.posx[i] + cx, data.posy[i] + cy);
        }
        if (pageMode)
            ch = vh * (pi + 1);
        this.setContentSize(cw, ch);
        tempDataPool.recover(data);
    }
    getLayoutChildren(data) {
        let i = 0, j = 0;
        data.invisibleCnt = 0;
        for (let child of this._owner.children) {
            if (child._nodeType !== 2)
                continue;
            if (this._foldInvisibles && !child._struct.enabled || child._getBit(NodeFlags.ESCAPE_LAYOUT))
                data.invisibles[data.invisibleCnt++] = i;
            else
                data.children[j++] = child;
            i++;
        }
        return j;
    }
    checkStretchParams(src, data) {
        if (data.invisibleCnt === 0)
            return src;
        let out = data.stretchParams;
        let j = 0, k = 0;
        let test = data.invisibles[j];
        for (let i = 0; i < src.length; i++) {
            if (i !== test)
                out[k++] = src[i];
            else {
                j++;
                if (j >= data.invisibleCnt)
                    test = -1;
                else
                    test = data.invisibles[j];
            }
        }
        return out;
    }
    handleStrecth(size, count, gap, params, sourceSizes, outSizes) {
        outSizes = outSizes || sourceSizes;
        if (count === 1 && !params[0]) {
            outSizes[0] = size;
            return;
        }
        let lineSize = Math.max(0, size - gap * (count - 1));
        let minChildSize = this._minChildSize;
        let lineSize2 = 0;
        let lineSize3 = 0;
        let ratio = 0;
        let hasRatio;
        for (let i = 0; i < count; i++) {
            let param = params[i] || defParam;
            if (param.ratio !== 0) {
                hasRatio = true;
                ratio += param.ratio;
            }
            else
                lineSize3 += sourceSizes[i];
        }
        ratio = Math.max(0, 1 - ratio);
        for (let i = 0; i < count; i++) {
            let param = params[i] || defParam;
            let itemSize = sourceSizes[i];
            if (hasRatio) {
                if (param.ratio !== 0)
                    itemSize = Math.floor(lineSize * param.ratio);
                else
                    itemSize = ratio * (itemSize / lineSize3);
            }
            if (!param.fixed) {
                let min = param.min !== 0 ? param.min : minChildSize;
                if (itemSize < min)
                    itemSize = min;
                if (param.max > 0 && itemSize > param.max)
                    itemSize = param.max;
            }
            outSizes[i] = itemSize;
            lineSize2 += itemSize;
        }
        let dist = lineSize2 - lineSize;
        if (dist > 0) {
            let round = 0;
            while (dist > 0) {
                let k = 0;
                let lineSize3 = 0;
                for (let i = 0; i < count; i++) {
                    let param = params[i] || defParam;
                    if (param.fixed) {
                        limit[i] = null;
                        continue;
                    }
                    let min = param.min !== 0 ? param.min : minChildSize;
                    let ts = outSizes[i];
                    if (ts > min
                        && (round >= 2
                            || round === 0 && param.priority > 0
                            || round === 1 && (param == defParam || param.ratio === 0 && param.priority >= 0))) {
                        limit[i] = min;
                        lineSize3 += ts;
                        k++;
                    }
                    else
                        limit[i] = null;
                }
                if (k === 0) {
                    round++;
                    if (round > 2)
                        break;
                    else
                        continue;
                }
                let ps = dist / k;
                let ps2 = 0;
                for (let i = 0; i < count; i++) {
                    let min = limit[i];
                    if (min == null)
                        continue;
                    ps2 += ps;
                    k--;
                    if (ps2 < 0) {
                        if (k !== 0)
                            continue;
                        else
                            ps2 = Math.floor(ps2);
                    }
                    let ts = outSizes[i];
                    ps2 = Math.ceil(ps2);
                    ts = Math.max(ts - ps2, min);
                    ps2 = ps - ps2;
                    dist -= (outSizes[i] - ts);
                    outSizes[i] = ts;
                }
                dist = Math.floor(dist);
                round++;
            }
        }
        else if (dist < 0) {
            let round = 0;
            dist = -dist;
            while (dist > 0) {
                let k = 0;
                let lineSize3 = 0;
                for (let i = 0; i < count; i++) {
                    let param = params[i] || defParam;
                    ;
                    if (param.fixed) {
                        limit[i] = null;
                        continue;
                    }
                    let max = param.max !== 0 ? param.max : 1000000;
                    let ts = outSizes[i];
                    if (ts < max
                        && (round >= 2
                            || round === 0 && param.priority > 0
                            || round === 1 && (param == defParam || param.ratio === 0 && param.priority >= 0))) {
                        limit[i] = max;
                        lineSize3 += ts;
                        k++;
                    }
                    else
                        limit[i] = null;
                }
                if (k === 0) {
                    round++;
                    if (round > 2)
                        break;
                    else
                        continue;
                }
                let ps = dist / k;
                let ps2 = 0;
                for (let i = 0; i < count; i++) {
                    let max = limit[i];
                    if (max == null)
                        continue;
                    ps2 += ps;
                    k--;
                    if (ps2 < 1) {
                        if (k !== 0)
                            continue;
                        else
                            ps2 = 1;
                    }
                    let ts = outSizes[i];
                    ps2 = Math.floor(ps2);
                    ts = Math.min(ts + ps2, max);
                    ps2 = ps - ps2;
                    dist -= (ts - outSizes[i]);
                    outSizes[i] = ts;
                }
                dist = Math.ceil(dist);
                round++;
            }
        }
    }
    static refreshAllLayouts(caller) {
        let len = _dirtyLayouts.length;
        if (len === 0)
            return;
        if (caller) {
            for (let i = 0; i < len; i++) {
                let layout = _dirtyLayouts[i];
                if (layout && caller.isAncestorOf(layout._owner)) {
                    _dirtyLayouts[i] = null;
                    layout.refresh();
                }
            }
        }
        else {
            _timerAdded = false;
            for (let i = 0; i < len; i++) {
                let layout = _dirtyLayouts[i];
                if (layout) {
                    _dirtyLayouts[i] = null;
                    layout.refresh();
                }
            }
            if (_dirtyLayouts.length > len)
                _dirtyLayouts.splice(0, len);
            else
                _dirtyLayouts.length = 0;
        }
    }
}
var _timerAdded = false;
var _dirtyLayouts = [];
class TempData {
    constructor() {
        this.children = [];
        this.invisibles = [];
        this.invisibleCnt = 0;
        this.stretchParams = [];
        this.posx = [];
        this.posy = [];
        this.width = [];
        this.swidth = [];
        this.height = [];
        this.sheight = [];
    }
}
const tempDataPool = Pool.createPool(TempData);
const limit = [];
const s_rect = new Rectangle();
const defParam = new StretchParam();
